'use strict';

window.console || (window.console = {
	log: function log() {}
});
var KIMPO_DO = window.KIMPO_DO || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = 'kimpo-do.com';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	KIMPO_DO = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test.kimpo-do.connecty.com|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (e) {
				var speed = 1200;
				if (/#/.test(e.currentTarget.href)) {
					scrollToObject(e.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;
				if (hash !== '#pagetop') {
					if (KIMPO_DO.va.window.width >= KIMPO_DO.va.device.sp) {
						pos -= 70;
					}
				}
				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');
			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(a);
				} else {
					$pagetop.removeClass(a);
				}
				if (footerPos <= pagetopPos) {
					$pagetop.addClass('is-bottom');
				} else {
					$pagetop.removeClass('is-bottom');
				}
			});
		},
		reserveBtn: function reserveBtn() {
			var $reserveBtn = $('.footer-reserveBtn');

			// 京橋本店のみボタンなし
			if (KIMPO_DO.va.pathname === '/kimpo-do/shop/5610.html') {
				$reserveBtn.remove();
			} else {
				$(window).scroll(function (e) {
					var $this = $(e.currentTarget);
					var thisScroll = $this.scrollTop();

					if (KIMPO_DO.va.pathname === '/kimpo-do/' || KIMPO_DO.va.pathname === '/kimpo-do/index.html') {
						if (thisScroll > '500') {
							$reserveBtn.addClass(a);
						} else {
							$reserveBtn.removeClass(a);
						}
					} else {
						$reserveBtn.addClass(a);
					}
				});
			}
		},
		headerMenu: function headerMenu() {
			var $hamburger = $('.header-hamburger');
			var $header = $('.header');
			var $nav = $('.header-nav');
			var $overlay = $('.header-overlay');
			var scrollTopNow = void 0,
			    startPos = 0;

			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};

			// 言語選択部分
			$('.js-lang-toggle').on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-lang-toggleBlock').stop().slideToggle(600);
			});
			$('.header-lang .js-lang-toggleBlock').parents('.pos_relative').on('mouseleave', function () {
				$('.header-lang .js-lang-toggle').removeClass(a);
				$('.header-lang .js-lang-toggleBlock').stop().slideUp(600);
			});
			// sp
			$('.header-lang-sp .js-lang-toggleBlock').parents('.pos_relative').on('mouseleave', function () {
				$('.header-lang-sp .js-lang-toggle').removeClass(a);
				$('.header-lang-sp .js-lang-toggleBlock').stop().slideUp(600);
			});

			$hamburger.on('click', function (e) {
				$(e.currentTarget).toggleClass(a);
				if ($nav.hasClass(a)) {
					$nav.removeClass(v);
					$overlay.removeClass(v);
					setTimeout(function () {
						$nav.removeClass(a);
						$overlay.removeClass(a);
					}, 400);
					fixedOffContainer();
				} else {
					fixedOnContainer();
					$overlay.addClass(a);
					$nav.addClass(a);
					setTimeout(function () {
						$overlay.addClass(v);
						$nav.addClass(v);
					});
				}
			});

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var thisScroll = $this.scrollTop();
				var browserTop = 0;
				var browserBottom = window.innerHeight ? window.innerHeight : $(window).height();
				browserBottom = $('body').height() - browserBottom;
				if (KIMPO_DO.va.window.width > KIMPO_DO.va.device.sp) {
					// PCサイズではスクロール時に最小化
					if (thisScroll === 0) {
						$header.removeClass('is-small');
					} else {
						$header.addClass('is-small');
					}
				} else {
					// iphone バウンス対策
					if (thisScroll < browserTop) {
						thisScroll = 0;
					} else if (thisScroll >= browserBottom) {
						thisScroll = startPos + 1;
					}
					// SPサイズでは下スクロール時に消える、上スクロール時に表示
					if (thisScroll - startPos > 0) {
						$header.addClass('is-hide');
					} else {
						$header.removeClass('is-hide');
					}
					startPos = thisScroll;
				}
			});
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.pageTop();
			_this.reserveBtn();
			_this.headerMenu();

			svg4everybody();
		}
	};

	$(function () {
		return KIMPO_DO.localDecision() ? KIMPO_DO.localLoading() : KIMPO_DO.loadDelayScript();
	});
})(window.jQuery);